import { SVGProps } from 'react';

export const ReflectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 100 100"
    fill="none"
    {...props}
  >
    <rect width="100" height="100" rx="22" fill="#f8f6f0" />
    <circle cx="32.51" cy="50" r="13.26" stroke="#1a1b1a" strokeWidth="4.5" />
    <circle cx="67.5" cy="50" r="15.51" fill="#1a1b1a" />
  </svg>
);
